import { LogOut } from 'lucide-react';
import { queryClient } from '../lib/queryClient';
import { useAuthStore } from '../lib/auth-store';

export function Header() {
  const user = useAuthStore((s) => s.user);
  const storeLogout = useAuthStore((s) => s.logout);

  const handleLogout = () => {
    queryClient.clear();
    storeLogout();
  };

  return (
    <header className="flex items-center justify-end h-16 px-6 border-b border-border bg-surface">
      <div className="flex items-center gap-3">
        <span className="text-sm text-text-secondary">{user?.fullName ?? user?.email}</span>
        <button
          onClick={handleLogout}
          className="p-2 rounded-md text-text-muted hover:text-danger hover:bg-surface-hover transition-colors"
          title="Logout"
        >
          <LogOut size={18} />
        </button>
      </div>
    </header>
  );
}
